module.exports = __webpack_public_path__ + "img/integra-logo-gris.a42a55f3.svg";